import React from 'react';

/**
 * The window of runs a competitor count covers, named by the backend (`scope.label`). One
 * element used by both the threat table and its drawer, so the two read the same string, and
 * kept apart from the surrounding sentences so they never have to repeat the run count.
 *
 * @param {{label?: string|null}} props renders nothing without a label
 */
export default function WindowLabel({ label }) {
  if (!label) return null;
  return (
    <span
      data-testid="window-label"
      className="inline-flex items-center rounded bg-gray-100 dark:bg-gray-800 px-1.5 py-0.5 text-[11px] font-medium text-gray-700 dark:text-gray-300"
    >
      Window: {label}
    </span>
  );
}
